import DynamicField from "../DynamicField";

export default function FilterGroup({ group }) {
  return (
    <div
      className={`flex flex-row w-full ${group.layout} justify-between ${
        group.align ?? "items-end"
      } gap-2`}
      key={group.id}
    >
      {group.fields.map((field) => (
        <div key={field.id} className={`${field.width}`}>
          <DynamicField {...field} />
        </div>
      ))}
    </div>
  );
}
